<template>
  <div class="vessel-route-path" v-if="stops.length">
    <div class="vessel-route-path__scroll">
      <div class="vessel-route-path__track">
        <template v-for="(stop, idx) in stops">
          <div
            :key="'n-'+idx"
            class="vessel-route-path__node"
            :class="{
              'is-passed': stop.passed,
              'is-current': stop.current || stop.isShipPosition,
              'is-ship': !!stop.isShipPosition,
              'is-future': !stop.passed && !stop.current && !stop.isShipPosition
            }"
          >
            <div class="vessel-route-path__port">{{ stop.portCn || stop.port || '--' }}</div>
            <div class="vessel-route-path__code">{{ stop.isShipPosition ? 'NOW' : (stop.portCode || '') }}</div>
            <div class="vessel-route-path__dot"></div>
            <div class="vessel-route-path__time">
              <span class="tag">{{ stop.nodeTag || (stop.passed ? 'ATD' : (stop.isShipPosition ? 'NOW' : 'ETA')) }}</span>
              {{ stop.nodeTimeShort || stop.nodeTime || '--' }}
            </div>
          </div>
          <div
            v-if="idx < stops.length - 1"
            :key="'l-'+idx"
            class="vessel-route-path__leg"
            :class="{
              'is-passed': !!stop.passed || !!stop.isShipPosition,
              'is-future': !stop.passed && !stop.isShipPosition
            }"
          >
            <div class="vessel-route-path__leg-line"></div>
            <div v-if="stop.sailDurationText" class="vessel-route-path__leg-dur">{{ stop.sailDurationText }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VesselRoutePath',
  props: {
    planBerths: { type: Array, default: () => [] }
  },
  computed: {
    stops() {
      return (this.planBerths || []).filter(
        p => p && (p.isShipPosition || p.portCode || p.port || p.portCn)
      )
    }
  }
}
</script>

<style scoped>
.vessel-route-path {
  width: 100%;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 8px 8px;
  margin-bottom: 12px;
}
.vessel-route-path__scroll {
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.vessel-route-path__scroll::-webkit-scrollbar {
  display: none;
  height: 0;
}
.vessel-route-path__track {
  display: flex;
  align-items: flex-start;
  min-width: max-content;
  padding: 4px 8px 8px;
}
.vessel-route-path__node {
  width: 110px;
  text-align: center;
  flex-shrink: 0;
  position: relative;
}
.vessel-route-path__port {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
  min-height: 18px;
}
.vessel-route-path__code {
  font-size: 11px;
  color: #909399;
  margin-bottom: 8px;
}
.vessel-route-path__dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin: 0 auto 8px;
  border: 3px solid #c0c4cc;
  background: #fff;
  box-sizing: border-box;
}
.vessel-route-path__time {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
}
.vessel-route-path__time .tag {
  color: #909399;
  margin-right: 2px;
}
.vessel-route-path__node.is-passed .vessel-route-path__dot,
.vessel-route-path__node.is-current .vessel-route-path__dot {
  border-color: #1b6cff;
  background: #1b6cff;
}
.vessel-route-path__node.is-current .vessel-route-path__dot {
  box-shadow: 0 0 0 4px rgba(27, 108, 255, 0.18);
}
.vessel-route-path__node.is-ship .vessel-route-path__dot {
  border-color: #e6a23c;
  background: #e6a23c;
  box-shadow: 0 0 0 4px rgba(230, 162, 60, 0.22);
}
.vessel-route-path__node.is-ship .vessel-route-path__port,
.vessel-route-path__node.is-ship .vessel-route-path__time {
  color: #e6a23c;
}
.vessel-route-path__node.is-passed .vessel-route-path__port,
.vessel-route-path__node.is-current .vessel-route-path__port {
  color: #1b6cff;
}
.vessel-route-path__node.is-future .vessel-route-path__port,
.vessel-route-path__node.is-future .vessel-route-path__time {
  color: #909399;
}
.vessel-route-path__leg {
  width: 72px;
  flex-shrink: 0;
  position: relative;
  height: 14px;
  margin-top: 44px;
}
.vessel-route-path__leg-line {
  position: absolute;
  left: 0;
  right: 0;
  top: 5px;
  height: 3px;
  border-radius: 2px;
  background: #dcdfe6;
}
.vessel-route-path__leg.is-passed .vessel-route-path__leg-line {
  background: #1b6cff;
}
.vessel-route-path__leg.is-future .vessel-route-path__leg-line {
  background: repeating-linear-gradient(
    90deg,
    #c0c4cc 0,
    #c0c4cc 6px,
    transparent 6px,
    transparent 10px
  );
  height: 2px;
  top: 6px;
}
.vessel-route-path__leg-dur {
  position: absolute;
  left: 50%;
  top: -16px;
  transform: translateX(-50%);
  font-size: 11px;
  color: #909399;
  white-space: nowrap;
}
</style>
